<template>
  <div>
    <card-toolbar
      id="ip_filter"
    >
      <template #actions>
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn icon v-on="on" @click="loadFilters">
              <v-icon outline>
                autorenew
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $tc('reload') }}</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn icon v-on="on" @click="createFilter">
              <v-icon outline>
                add
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $tc('new_ip_filter') }}</span>
        </v-tooltip>

        <v-switch
          :label="$tc('enable')"
          v-model="activate"
          color="green"
          class="ma-0 pa-0 mt-4"
          :loading="loadingEnable"
        />
      </template>
    </card-toolbar>

    <v-card flat class="rounded-lg mb-8" outlined style="background: transparent;">
      <v-row class="pa-0">
        <v-col cols="12">
          <v-card flat style="background: transparent;">
            <v-data-table
              style="background: transparent;"
              :footer-props="{ 'items-per-page-options': itemsPerPageOptions }"
              hide-default-footer
              :headers="headers"
              :items="filter.filters"
              :loading="loading"
              mobile-breakpoint=""
            >
              <template
                v-if="filter.filters.length"
                #body="{ items }"
              >
                <tbody>
                  <tr v-for="item in items" :key="item.id">
                    <td>{{ item.usr }}</td>
                    <td>{{ item.addr }}</td>
                    <td>
                      <v-row no-gutters justify="end">
                        <v-tooltip bottom>
                          <template #activator="{ on }">
                            <v-icon
                              v-on="on"
                              @click="deleteFilter(item.usr, item.addr)"
                            >
                              delete
                            </v-icon>
                          </template>
                          <span>{{ $tc('delete') }}</span>
                        </v-tooltip>
                      </v-row>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <filter-new-modal
      :open="showCreateFilterModal"
      @close="closeCreateFilterModal"
      @success="filterCreatedWithSuccess"
    />

    <confirm-modal
      id="HsmIpFilterPage_confirm_modal"
      :open="showConfirmModal"
      :title="$tc('activate_filter')"
      :message="$tc('confirm_filter_activate')"
      @negative="cancelActivation"
    >
      <template #actions>
        <v-spacer />
        <v-btn
          id="ConfirmModal_negative"
          text
          @click="cancelActivation"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
          id="ConfirmModal_positive"
          text
          @click="activateFilter"
        >
          {{ $t('activate') }}
        </v-btn>
      </template>
    </confirm-modal>
  </div>
</template>

<script>
import FilterNewModal from './modals/FilterNewModal'
import CardToolbar from '@/components/CardToolbar'
import ConfirmModal from '@/components/ConfirmModal.vue'

export default {
  components: {
    FilterNewModal,
    CardToolbar,
    ConfirmModal
  },
  created  () {
    this.loadFilters()
  },
  data () {
    return {
      itemsPerPageOptions: [10, 20, 30, -1],
      loading: false,
      search: '',
      activate: false,
      isEnabled: false,
      showCreateFilterModal: false,
      showConfirmModal: false,
      loadingEnable: false
    }
  },
  computed: {
    filter () {
      return this.$store.state.hsm.ipFilter
    },
    headers () {
      const name = this.$tc('name', 2)
      const address = this.$t('addr')
      const action = this.$tc('action', 2)

      return [
        {
          text: name,
          align: 'left',
          sortable: true,
          value: 'usr'
        },
        {
          text: address,
          align: 'left',
          sortable: true,
          value: 'addr'
        },
        {
          text: action,
          align: 'right',
          sortable: false,
          value: false
        }
      ]
    }
  },
  methods: {
    loadFilters () {
      this.loading = true
      this.$store.dispatch('hsm/getIpFilter').then(() => {
        this.loading = false
      })
    },

    createFilter () {
      this.showCreateFilterModal = true
    },
    closeCreateFilterModal () {
      this.showCreateFilterModal = false
    },
    filterCreatedWithSuccess () {
      this.$notify.success({})
      this.loadFilters()
      this.showCreateFilterModal = false
    },
    activateConfirm () {
      this.showConfirmModal = true
    },
    cancelActivation () {
      this.activate = false
      this.showConfirmModal = false
    },
    activateFilter () {
      this.loadingEnable = true
      this.$store
        .dispatch('hsm/setIpFilter', {
          body: {
            enabled: this.activate ? 1 : 0
          }
        })
        .then(() => {
          this.$notify.success({})
          this.showConfirmModal = false
          this.loadFilters()
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
        .finally(() => {
          this.loadingEnable = false
        })
    },
    deleteFilter (user, ip) {
      const filterSelected = (user ? user + '@' : '') + ip

      this.$notify.confirm({ title: this.$t('remove_filter'), message: this.$t('confirm_filter_delete', [filterSelected]) }, () => {
        return this.delete(user, ip)
      })
    },
    delete (user, ip) {
      this.$store
        .dispatch('hsm/delIpFilter', {
          body: {
            usr: user,
            addr: ip
          }
        })
        .then(() => {
          this.$notify.success({})
          this.loadFilters()
        })
        .catch(err => {
          const errObj = this.$store.getters['error/getErrorObj'](err)
          if (errObj) {
            this.$notify.hsmError(errObj, err)
          } else {
            this.$notify.error({ message: err })
          }
        })
    }
  },
  watch: {
    filter (val) {
      if (!this.isEnabled) {
        this.activate = (val.enabled !== 0)
        if (!val.enabled) this.isEnabled = true
      }
    },
    activate: async function (val) {
      if (this.isEnabled) {
        if (val) {
          this.activateConfirm()
        } else {
          this.activateFilter()
        }
      } else {
        this.isEnabled = true
      }
    }
  }
}
</script>
